import API from '../../../api/endpoints'
import Vue from 'vue'

export default {
  getOptions () {
    return Vue.http.get(API.GET_ENTITIES('options'), {
      headers: { 'X-Lazy-Fetch': '0' }
    })
  },
  getBrandGroups () {
    return Vue.http.get(API.GET_ENTITIES('brand-group'), {
      headers: { 'X-Lazy-Fetch': '0' }
    })
  },
  getCalculations () {
    return Vue.http.get(API.GET_ENTITIES('calculation'), {
      headers: { 'X-Lazy-Fetch': '0' }
    })
  },
  getOptionTypes () {
    return Vue.http.get(API.GET_ENTITIES('option-types'), {
      headers: { 'X-Lazy-Fetch': '0' }
    })
  },
  getChargeProfiles () {
    return Vue.http.get(API.GET_ADMIN_ENTITY_BY_FULL_SEARCH('financial-profile'), {
      headers: { 'X-Lazy-Fetch': '0' },
      params: { category: 'CHARGE' }
    })
  },
  getFinancialCodes () {
    return Vue.http.get(API.GET_ENTITIES('financial-code'), {
      headers: { 'X-Lazy-Fetch': '0' }
    })
  },
  getCurrencies () {
    return Vue.http.get(API.GET_ENTITIES('currency'), {
      headers: { 'X-Lazy-Fetch': '0' }
    })
  },
  getJobTypes () {
    return Vue.http.get(API.GET_ENTITIES('job-type'), {
      headers: { 'X-Lazy-Fetch': '0' }
    })
  },
  getRoles () {
    return Vue.http.get(API.GET_ENTITIES('role'), {
      headers: { 'X-Lazy-Fetch': '0' }
    })
  },
  getCountries () {
    return Vue.http.get(API.GET_ENTITIES('country'), {
      headers: { 'X-Lazy-Fetch': '0' }
    })
  },
  getExRates () {
    return Vue.http.get(API.GET_ENTITIES('exchange-rate'), {
      headers: { 'X-Lazy-Fetch': '0' }
    })
  },
  getPartyGroups () {
    return Vue.http.get(API.GET_ENTITIES('party-group'), {
      headers: { 'X-Lazy-Fetch': '0' }
    })
  },
  getPortAreas () {
    return Vue.http.get(API.GET_ENTITIES('port-area'), {
      headers: { 'X-Lazy-Fetch': '0' }
    })
  },
  getServiceTypes () {
    return Vue.http.get(API.GET_ENTITIES('service-type'), {
      headers: { 'X-Lazy-Fetch': '0' }
    })
  },
  getUserGroups () {
    return Vue.http.get(API.GET_ENTITIES('user-group'), {
      headers: { 'X-Lazy-Fetch': '0' }
    })
  },
  getSpreadsheetDescriptorProperties (type) {
    return Vue.http.get(API.SPREADSHEET_PROPERTIES(type), {
      headers: { 'X-Lazy-Fetch': '0' }
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/systemoptions/store/service.js